import { render } from "./TimelineObjectView.vue?vue&type=template&id=96ab788c"
import script from "./TimelineObjectView.vue?vue&type=script&lang=js"
export * from "./TimelineObjectView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sjoshi6/git/openmct/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__